export const makeApiUrl = (path: string) => `${process.env.REACT_APP_REST_API_ENDPOINT || '/'}api/${path}`;
